// Toolbar item registry - maps string keys to components
import { BoldButton } from './BoldButton';
import { BulletListButton } from './BulletListButton';
import { LinkButton } from './LinkButton';
import { HeadingSelector } from './HeadingSelector';
import { FontSizeSelector } from './FontSizeSelector';
import { Separator } from './Separator';
import { TextColorButton } from './TextColorButton';

export type ToolbarItemType =
  | 'HeadingSelector'
  | 'FontSizeSelector'
  | 'Bold'
  | 'BulletList'
  | 'Link'
  | 'TextColor'
  | 'Separator';

export const TOOLBAR_ITEMS_REGISTRY: Record<ToolbarItemType, React.ComponentType> = {
  HeadingSelector: HeadingSelector,
  FontSizeSelector: FontSizeSelector,
  Bold: BoldButton,
  BulletList: BulletListButton,
  Link: LinkButton,
  TextColor: TextColorButton,
  Separator: Separator,
};

// Default toolbar configuration
export const DEFAULT_TOOLBAR_ITEMS: ToolbarItemType[] = [
  'FontSizeSelector',
  'Separator',
  'Bold',
  'BulletList',
  'Link',
];
